import React from 'react'
import {
    Route,
    Switch,
    Redirect,
    BrowserRouter as Router
} from 'react-router-dom'
//---REDUX
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import allTheActions from '../actions'
//---
import styled from "styled-components"
import Auth from '../screens/auth'
import Dashboard from '../screens/dashboard'
import CreateLicence from '../screens/create-licence'
import Clubs from '../screens/clubs'
import ClubView from '../screens/club-view'
import RecapRenewal from "../screens/recap-renewal"
import ConfirmRenewal from "../screens/confirm-renewal"
import LicenceView from "../screens/licence-view"
import CreateUser from "../screens/create-user"
import Profile from "../screens/profile"
import ClubSettings from "../screens/club-settings"
import Waiting from "../screens/waiting-licences"
import SoloLicences from "../screens/solo-licences"
import CreateClub from "../screens/create-club"
import Expired from "../screens/expired";
import ConfirmCreation from "../screens/confirm-creation";

const Container = styled.div`
  margin: auto;
  margin-top: 100px;
  box-sizing: border-box;
  width: auto;
  max-width: 1280px;
  min-height: calc(~"100vh - 0px");
  padding: 15px 0;
`

const loadState = () => {
    try {
        const serializedState = localStorage.getItem('persist:3fts')
        if (serializedState === null) return undefined
        return JSON.parse(serializedState)
    } catch (err) {
        return undefined
    }
}

const Routing = (...props) => {
    loadState()
    const token = localStorage.getItem('token')

    const PublicRoute = ({component: Component, ...props}) => {
        return (
            <Route
                {...props}
                render={innerProps => (token && token !== "guest") ? <Redirect to='/dashboard'/> :
                    <Component {...innerProps} />
                }
            />
        )
    }

    const PrivateRoute = ({component: Component, ...props}) => {
        return (
            <Container>
                <Route
                    {...props}
                    render={innerProps =>
                        (token && token !== "guest") ? <Component {...innerProps} /> : <Redirect to='/'/>
                    }
                />
            </Container>
        )
    }

    return (
        <Router>
            <Switch>
                <PublicRoute exact path='/' component={Auth}/>
                <PrivateRoute exact {...props} path='/create-licence' component={CreateLicence}/>
                <PrivateRoute exact {...props} path='/dashboard' component={Dashboard}/>
                <PrivateRoute exact {...props} path='/create-user' component={CreateUser}/>
                <PrivateRoute exact {...props} path='/clubs' component={Clubs}/>
                <PrivateRoute exact {...props} path='/club/:id' component={ClubView}/>
                <PrivateRoute exact {...props} path='/create-club' component={CreateClub}/>
                <PrivateRoute exact {...props} path='/recap-renewal' component={RecapRenewal}/>
                <PrivateRoute exact {...props} path='/confirm-renewal/:type' component={ConfirmRenewal}/>
                <PrivateRoute exact {...props} path='/confirm-creation' component={ConfirmCreation}/>
                <PrivateRoute exact {...props} path='/licence/:id' component={LicenceView}/>
                <PrivateRoute exact {...props} path='/profile' component={Profile}/>
                <PrivateRoute exact {...props} path='/club-settings/:id' component={ClubSettings}/>
                <PrivateRoute exact {...props} path='/waiting' component={Waiting}/>
                <PrivateRoute exact {...props} path='/licences-solo' component={SoloLicences}/>
                <PrivateRoute exact {...props} path='/expired' component={Expired}/>
            </Switch>
        </Router>
    )
}

const mapStateToProps = state => ({
    loginState: state.login
})

const mapDispatchToProps = () => dispatch => ({
    actions: {
        login: bindActionCreators(allTheActions.login, dispatch)
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Routing)
